import _ from 'lodash';

const events = {
  "$W_INTERACTION_PREVIEW": {
    "eventId": 150,
    "endpoint": 'platform-viewer',
    "src": 79,
    "params": {
      "page_url": "page_url"
    },
    "sampleRatio": 0
  },
  "$W_INTERACTION_SITE": {
    "eventId": 136,
    "endpoint": 'platform-viewer',
    "src": 79,
    "params": {
      "page_url": "page_url"
    },
    "sampleRatio": 0
  }
};

function getBIEvent (eventName) {
    return _.get(events, eventName);
}
export default getBIEvent;


// WEBPACK FOOTER //
// ./js/modules/privates/bi/events.es6